import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Store } from "@ngxs/store";
import { AuthSessionFacade } from "@services/auth-session/auth-session.facade";
import { UserState } from "@store/user/user.state";
import { EMPTY, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class AuthenticatedPreloadStrategy implements PreloadingStrategy {
  constructor(
    private readonly store: Store,
    private readonly authSessionFacade: AuthSessionFacade,
  ) {}

  public preload(route: Route, load: () => Observable<unknown>) {
    if (!route.data?.["preload"]) {
      return EMPTY;
    }

    const isLoggedIn = this.store.selectSnapshot(UserState.isLoggedIn);
    if (isLoggedIn || this.authSessionFacade.hasSession()) {
      return load();
    }

    return EMPTY;
  }
}
